import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface RouteInfo {
  path: string;
  title: string;
}

export const MetaTitle: React.FC = () => {
  const pathName = useLocation().pathname;
  const subTitle = 'ARGUS';

  const routes: RouteInfo[] = [
    { path: '/', title: 'ログイン' },
    { path: '/auth/password_reset', title: 'パスワード忘れ' },
    { path: '/auth/password_reset/complete', title: 'パスワード忘れメール送信完了' },
    { path: '/auth/password_change', title: 'パスワード変更' },
    { path: '/auth/password_change/complete', title: 'パスワード変更完了' },
    { path: '/ai-ocr', title: 'AI文字読取' },
    { path: `/ai-ocr/result/:id`, title: 'AI文字読取結果' },
    { path: '/ai-ocr/delete/complete', title: 'AI読取結果削除完了' },
    { path: '/ai-ocr/demo', title: 'AI文字読取デモ' },
    { path: '/ai-ocr/demo/add', title: 'AI文字読取デモ新規登録' },
    { path: '/staff', title: '担当者一覧' },
    { path: '/staff/invite', title: '担当者招待' },
    { path: '/staff/invite/complete', title: '担当者招待完了' },
    { path: '/staff/invite/cancel', title: '担当者招待取消完了' },
    { path: '/staff/register', title: '担当者登録' },
    { path: '/staff/register/complete', title: '担当者登録完了' },
    { path: '/staff/edit', title: '担当者編集' },
    { path: '/staff/edit/complete', title: '担当者編集完了' },
    { path: '/staff/delete/complete', title: '担当者削除完了' },
    { path: '/groups/manage', title: 'グループ管理' },
    { path: '/groups/create', title: 'グループ作成' },
    { path: '/groups/:groupId/edit', title: 'グループ編集' },
    { path: '/groups/:groupId/ai-ocr', title: 'AI文字読取' },
    { path: '/groups/:groupId/ai-ocr/result/:id', title: 'AI文字読取結果' },
    { path: '/groups/:groupId/ai-ocr/delete/complete', title: 'AI読取結果削除完了' },
  ];

  const getPageTitle = (path: string): string => {
    // 完全一致するルートを探す
    const exactRoute = routes.find(r => r.path === path);
    if (exactRoute) return exactRoute.title;

    // 完全一致しない場合、パラメータを含むルートを探す
    const paramRoute = routes.find(r => {
      const routeParts = r.path.split('/');
      const pathParts = path.split('/');

      if (routeParts.length !== pathParts.length) return false;

      return routeParts.every((part, index) => part.startsWith(':') || part === pathParts[index]);
    });

    return paramRoute ? paramRoute.title : 'ページが見つかりません';
  };

  return (
    <Helmet>
      <title>
        {getPageTitle(pathName)} | {subTitle}
      </title>
    </Helmet>
  );
};

export default MetaTitle;
